import styled from 'styled-components/macro';
import {useState} from "react";
import {useHistory} from "react-router-dom";
import {
    Button,
    Checkbox,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Textarea
} from "@chakra-ui/react";
import {useFeedback} from "../store/feedback";
import {useCreateMessage} from "../api/message";
import {useQuery} from "../utils/router";

const CreateMessage = styled(({onClose, recipient}) => {
    const history = useHistory();
    const query = useQuery();
    const [message, setMessage] = useState({
        recipient: (query.user || recipient) || '',
        subject: '',
        content: '',
        liability: false,
    });
    const set = (name) => (value) => setMessage((message) => ({...message, [name]: value}));
    const [posting, setPosting] = useState(false);

    const feedback = useFeedback();
    const createMessage = useCreateMessage(feedback.channel);
    const handleSave = async () => {
        if (posting || !message.liability) return;
        try {
            setPosting(true);
            const {messages} = await createMessage(message);
            onClose();
            history.replace(`/message/${  messages[0].id}`);
        } catch {
            // error is displayed
        }
        setPosting(false);
    };

    return (
        <Modal
            isOpen
            onClose={onClose}
            size={'lg'}
            closeOnOverlayClick={false}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Send a message</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <Stack spacing={'5'}>

                        <FormControl>
                            <FormLabel>Title</FormLabel>
                            <Input placeholder="" value={message.subject}
                                   onChange={(e) => set('subject')(e.currentTarget.value)}/>
                        </FormControl>

                        <FormControl>
                            <FormLabel>Recipient</FormLabel>
                            <Input placeholder="" value={message.recipient}
                                   onChange={(e) => set('recipient')(e.currentTarget.value)}/>
                        </FormControl>

                        <FormControl>
                            <FormLabel>Content</FormLabel>
                            <Textarea type="content" value={message.content} rows={5}
                                      onChange={(e) => set('content')(e.currentTarget.value)}
                            />
                        </FormControl>

                        <Checkbox size='sm' value={message.liability}
                                  onChange={(e) => set('liability')(e.target.checked)}>I understand there are better platforms for private discussions.</Checkbox>

                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={onClose}>Cancel</Button>
                    <Button variant="blue" isLoading={posting} onClick={handleSave}>
                        Send
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
})`
`;

export default CreateMessage;